// Dependency
import { Base64 } from 'js-base64';

import { server } from './../constants';

/**
 * logger console.log when system-environment is not produnction
 * @param  {...any} args
 */
export function logger(...args) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
}

export const issueOperations = {
  reciever: 'RECIEVER',
  features: 'FEATURES', // can manage labels, dimensions
  updateIssue: 'UPDATE-ISSUE',
  addComment: 'ADD-COMMENT',
  updateComment: 'UPDATE-COMMENT',
};

export const base64 = {
  encodeObj(obj) {
    let encode = '';
    try {
      let objToJson = JSON.stringify(obj);
      encode = Base64.encode(objToJson);
    } catch (error) {
      alert('Error base64.encodeObj, ', JSON.stringify(error));
    }
    return encode;
  },
  decodeObj(json) {
    let decode = '';
    try {
      let jsonToObject = Base64.decode(json);
      decode = JSON.parse(jsonToObject);
    } catch (error) {
      alert('Error base64.decodeObj, ', JSON.stringify(error));
    }
    return decode;
  },
  encode: Base64.encode,
  decode: Base64.decode,
};

/**
 * mergeArray, merge array items in list array examples [[1,2,3], [1,2,4]] => [1,2,3,4]
 * @param {*} arr list of array
 * @returns new array without duplicate element with another list
 */
export function mergeArray(arr = [[]]) {
  let ret = [];
  arr
    .reduce((acc, curr) => acc.concat(curr))
    .forEach((item) => {
      if (ret.indexOf(item) === -1) ret.push(item);
    });
  return ret;
}

/**
 * To format - datetime strings (from system-datetime) to language-sensitive date and time
 * (ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat)
 * @param {string} datetime datetime strings (ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date)
 * @param {string} locale, ex 'en-US', 'th-TH' ... etc.
 * @param {object} options, default {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false}
 * @return {string} date and time formatting by locale and options
 */
export function formatDatetime(props) {
  props = props === undefined ? {} : props;
  let datetime = props.datetime ? props.datetime : null;
  let locale = props.locale ? props.locale : 'en-GB';
  let languageId = props.languageId ? props.languageId : null;
  if (languageId) {
    if (languageId === 'TH') {
      locale = 'th-TH';
    }
  }
  let options = props.options ? props.options : {};
  let opts = {
    year: options.year ? options.year : 'numeric',
    month: options.year ? options.month : '2-digit',
    day: options.day ? options.day : '2-digit',
    hour: options.hour ? options.hour : 'numeric',
    minute: options.minute ? options.minute : 'numeric',
    //second: options.second ? options.second : "numeric",
    hour12: options.hour12 ? options.hour12 : false,
  };
  if (datetime) {
    try {
      let date = datetime === 'now' ? new Date() : new Date(datetime);
      return `${new Intl.DateTimeFormat(locale, opts).format(date)}`;
    } catch (error) {
      console.error('Error in formatDatetime func: ', error);
    }
  }
  return '-';
}

export function formatDateYYYYTMMTdd(date) {
  let d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

export function getPeriodDateById(periodId) {
  var date = new Date();
  let dfEndDate = new Date(date.setDate(date.getDate()));

  let dfstartDate = '1900-12-31';
  let period = { startDate: '', endDate: formatDateYYYYTMMTdd(dfEndDate) };

  if (periodId === 'all') {
    period.startDate = dfstartDate;
  } else {
    let periodType = periodId[1];
    let periodAmou = Number(periodId[0]);
    let endDateSubNYear = dfEndDate;
    if (periodId[1] === 'y') {
      endDateSubNYear.setFullYear(endDateSubNYear.getFullYear() - periodAmou);
      period.startDate = formatDateYYYYTMMTdd(endDateSubNYear);
    }
  }

  return { ...period, dateStart: period.startDate, dateEnd: period.endDate };
}

/**
 *
 * @param {object|json-string} info
 */
export function JSON2HTML(
  info,
  unacceptKey = [
    'stack',
    'description',
    'number',
    'fileName',
    'lineNumber',
    'columnNumber',
    'config',
    'code',
  ]
) {
  let checkType = (t) => {
    if (t) {
      if (Array.isArray(t)) {
        return 'array';
      } else {
        return typeof t;
      }
    } else {
      return '';
    }
  };
  let infos = {};
  let keys = [];
  try {
    infos = checkType(info) === 'string' ? JSON.parse(info) : info;
  } catch (error) {
    infos = {
      note: 'Tranforming infomation fail',
      context: info,
    };
  }
  keys = Object.keys(infos);
  let htmls = keys.map((key, index) => {
    if (!unacceptKey.includes(key)) {
      let ifs = infos[key];
      let t = checkType(ifs);
      return `<div key=${index} style="padding-left: 30px">
              <h3 style="padding: 0; margin: 15px 0 0 0;">${key}: </h3>
              <div>
              ${
                t === 'object'
                  ? JSON2HTML(JSON.stringify(ifs))
                  : t === 'array'
                  ? JSON.stringify(ifs)
                  : ifs
              }
              </div>
            </div>`;
    } else {
      return '';
    }
  });
  return htmls.join('');
}

/**
 * clearLocalAccessData()
 * Clear ACCESS_TOKEN
 * Clear REFRESH_TOKEN
 * Clear USER_PROFILE
 */
export const clearLocalAccessData = () => {
  localStorage.removeItem(server.ACCESS_TOKEN_KEY);
  localStorage.removeItem(server.REFRESH_TOKEN_KEY);
  localStorage.removeItem(server.USER_PROFILE_KEY);
};

/**
 * {object} userProfiler
 * userProfiler.setToLocal() set user profile to localStorage
 * userProfiler.getFromLocal() get user profile (object type) from localStorage
 */
export const userProfiler = {
  /**
   * userProfile.setToLocal();
   * @param {object} userProfile { user, permission }
   * @param {object} userProfile.user,
   * @param {array} userProfile.permission,
   * @param {*} userProfileKey , User profile key of localStorage [Default = server.USER_PROFILE_KEY]
   */
  setToLocal(userProfile, userProfileKey = server.USER_PROFILE_KEY) {
    let { user: profile, permission } = userProfile;

    try {
      let {
        id,
        firstName,
        lastName,
        firstNameEn,
        lastNameEn,
        email,
        position,
        keycode,
        department,
        image,
        lastLogin,
        notifyCount,
      } = profile;
      let strUserProfile = JSON.stringify({
        user: {
          id,
          firstName,
          lastName,
          fullname: `${firstName} ${lastName}`,
          firstNameEn,
          lastNameEn,
          fullnameEn: `${firstNameEn} ${lastNameEn}`,
          email,
          position,
          keycode,
          department,
          image,
          lastLogin: formatDatetime({ datetime: lastLogin }),
          notifyCount,
        },
        permission,
      });
      let enUserProfile = Base64.encode(strUserProfile);
      localStorage.setItem(userProfileKey, enUserProfile);
    } catch (error) {
      alert('Errpr userProfiler.getLocal, ', JSON.stringify(error));
    }
  },
  /**
   * getFromLocal() get user profile (object type) from localStorage
   * @param {*} userProfileKey , User profile key of localStorage [Default = server.USER_PROFILE_KEY]
   * @return { user, permission }
   */
  getFromLocal(userProfileKey = server.USER_PROFILE_KEY) {
    let parseDeUserProfile = { user: {}, permission: { level: [] } };
    try {
      let enUserProfile = localStorage.getItem(userProfileKey);
      if (enUserProfile) {
        parseDeUserProfile = JSON.parse(Base64.decode(enUserProfile));
      }
    } catch (error) {
      alert('Errpr userProfiler.getLocal, ', JSON.stringify(error));
    }
    return parseDeUserProfile;
  },
};

/** 
 * openOriginalImage() open image on new tab.
 * @param {*} data 
 * https://stackoverflow.com/questions/27798126/how-to-open-the-newly-created-image-in-a-new-tab

 */
export function openOriginalImage(
  data,
  title = 'Reporting Breach: Original image'
) {
  // https://stackoverflow.com/questions/27798126/how-to-open-the-newly-created-image-in-a-new-tab
  let image = new Image();
  image.src = data;
  let w = window.open('', 'file');
  w.document.body.innerHTML = '';
  w.document.write(image.outerHTML);
  w.document.title = title;
}


/**
 * isManageIssue
 * @param {bool} readOnly Are you readOnly in issue
 * @param {bool} isWorker Are you readOnly of issue
 * @param {bool} processStatus Current processStatus of issue
 * @param {object} options { operation: operations, [issueWorker]|[user, createBy] }
 * @param {issueOperation} options.operation {reciever|updateIssue|addComment|updateComment} default updateIssue
 * @param {bool} options.creater Require if operation is updateIssue or updateComment

 * 10	TH	pending	รอดำเนินการ
 * 20	TH	received	เจ้าหน้าที่ รับเรื่อง
 * 30	TH	processing	เจ้าหน้าที่ ดำเนินการ
 * 40	TH	forward	ส่งต่อ
 * 90	TH	success	ดำเนินการเรียบร้อย
 * 99	TH	vote	ผู้แจ้ง ประเมิน
 */
 export function isManageIssue(readOnly, isWorker, processStatus, options) {
  options = options || {};
  options.operation = options.operation || issueOperations.updateIssue;
  options.isCreater = options.isCreater || null;

  let isManage = false;

  switch (options.operation) {
    case issueOperations.reciever:
      if (readOnly) {
        isManage = false;
      } else if (
        // if you are not wroker & processStatus = 10 (pending) you can recieve
        // and you are worker you can change processStatus else can not
        (isWorker === false && processStatus < 20) ||
        isWorker === true
      ) {
        isManage = true;
      } else {
        isManage = false;
      }
      break;
    case issueOperations.features:
      if (readOnly) {
        isManage = false;
      } else if (isWorker === true && processStatus >= 20) {
        isManage = true;
      } else {
        isManage = false;
      }
      break;
    case issueOperations.updateIssue:
      if (isWorker && processStatus >= 20) {
        isManage = true;
      } else {
        isManage = false;
      }
      break;
    case issueOperations.updateComment:
      if (options.isCreater && processStatus >= 20) {
        isManage = true;
      } else {
        isManage = false;
      }
      break;
    case issueOperations.addComment:
      if (readOnly) {
        isManage = false;
      } else if (processStatus >= 20) {
        isManage = true;
      } else {
        isManage = false;
      }
      break;
    default:
      isManage = false;
  }
  
  return isManage;
}

// setDeepState
// https://stackoverflow.com/questions/58975883/prevent-rerender-for-every-setstate-using-react-usestate-hook
export function setDeepState(state, newState, setState) {
  setState(Object.assign({}, state, newState));
}
